export const imageData = [
    {
        "imageUrl": require('@/assets/images/A_breathtaking_landscape_of_a_dense_forest_with_su.png'),
        "caption": "A breathtaking landscape of a dense forest with sun rays filtering through the tall trees, a serene lake reflecting the vibrant autumn colors, and distant mountains covered in mist.",
        "category": "Nature"
      },
      {
        "imageUrl": require('@/assets/images/A_serene_beach_scene_with_turquoise_waters_gently_.png'),
        "caption": "A serene beach scene with turquoise waters gently lapping against white sandy shores, surrounded by lush green palm trees with rugged cliffs in the background.",
        "category": "Nature"
      },
      {
        "imageUrl": require('@/assets/images/A_vibrant_mountain_landscape_during_sunset_with_sn.png'),
        "caption": "A vibrant mountain landscape during sunset with snow-capped peaks glowing in golden light, a flowing river winding through the valley, and colorful wildflowers in the foreground.",
        "category": "Nature"
      },
      {
        "imageUrl": require('@/assets/images/A_lush_green_meadow_dotted_with_colorful_wildflowe.png'),
        "caption": "A lush green meadow dotted with colorful wildflowers under a clear blue sky, with rolling hills covered in dense forest stretching towards the horizon.",
        "category": "Nature"
      },
      {
        "imageUrl": require('@/assets/images/A_stunning_modern_architectural_masterpiece_with_s.png'),
        "caption": "A stunning modern architectural masterpiece with sleek glass walls reflecting the cityscape, featuring a unique geometric design with sharp angles and a futuristic aesthetic.",
        "category": "Architecture"
      },
      {
        "imageUrl": require('@/assets/images/A_majestic_historical_castle_perched_on_a_hill,_su.png'),
        "caption": "A majestic historical castle perched on a hill, surrounded by lush gardens and overlooking a tranquil river. The ancient walls glow warmly under the golden sunset.",
        "category": "Architecture"
      },
      {
        "imageUrl": require('@/assets/images/A_picturesque_European_street_with_colorful,_narro.png'),
        "caption": "A picturesque European street with colorful, narrow buildings featuring charming balconies adorned with flower pots, cobblestone pathways, and a cozy café with outdoor seating.",
        "category": "Architecture"
      },
      {
        "imageUrl": require('@/assets/images/An_ancient_temple_with_towering_stone_pillars_cove.png'),
        "caption": "An ancient temple with towering stone pillars covered in moss, surrounded by dense jungle. Intricate carvings and sunlight filtering through vines create a mystical ambiance.",
        "category": "Architecture"
      },
      {
        "imageUrl": require('@/assets/images/A_beautifully_plated_gourmet_dish_featuring_seared.png'),
        "caption": "A beautifully plated gourmet dish featuring seared salmon on a bed of asparagus and creamy mashed potatoes, garnished with microgreens and a drizzle of balsamic glaze.",
        "category": "Food"
      },
      {
        "imageUrl": require('@/assets/images/A_vibrant_street_food_scene_featuring_a_colorful_t.png'),
        "caption": "A vibrant street food scene featuring a colorful taco loaded with fresh vegetables, juicy grilled meat, topped with cilantro, and a squeeze of lime in a bustling market setting.",
        "category": "Food"
      },
      {
        "imageUrl": require('@/assets/images/An_elegant_dessert_plate_featuring_a_rich_chocolat.png'),
        "caption": "An elegant dessert plate featuring a rich chocolate lava cake with molten center, served with vanilla ice cream, fresh raspberries, and mint leaves, beautifully presented.",
        "category": "Food"
      },
      {
        "imageUrl": require('@/assets/images/A_rustic_wooden_table_filled_with_an_assortment_of.png'),
        "caption": "A rustic wooden table filled with an assortment of cheeses, cured meats, olives, and freshly baked bread, arranged as a charcuterie board in a cozy, inviting setting.",
        "category": "Food"
      },
      {
        "imageUrl": require('@/assets/images/A_serene_coastal_scene_featuring_a_traditional_woo.png'),
        "caption": "A serene coastal scene featuring a traditional wooden fishing boat anchored near the shore, gently swaying on the turquoise sea with rocky cliffs and lush greenery in the background.",
        "category": "Boats"
      },
      {
        "imageUrl": require('@/assets/images/A_luxurious_yacht_sailing_on_the_open_sea_under_a_.png'),
        "caption": "A luxurious yacht sailing on the open sea under a clear blue sky, with a sleek design and pristine white exterior reflecting the sunlight as it glides smoothly on calm waters.",
        "category": "Boats"
      },
      {
        "imageUrl": require('@/assets/images/An_adventurous_scene_of_a_small_sailboat_navigating.png'),
        "caption": "An adventurous scene of a small sailboat navigating through rough ocean waves with dark stormy clouds looming overhead, creating a dramatic and thrilling maritime moment.",
        "category": "Boats"
      }
  ];